import Button from '@/components/Button.jsx';
import { FiArrowLeft } from '@/components/react-icons/main';
import DividerV2 from '@/components/v2/DividerV2.jsx';
import setPath from '@/lib/setPath.js';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors.js';
import selectors from '@/redux/selectors/selectors.js';
import { useSelector } from 'react-redux';

const WorkflowReturnToPublishedButton = () => {
  const workflowId = useArgSelector(selectors.param, 'workflowId');
  const workflowVersion = useArgSelector(selectors.param, 'workflowVersion');
  const publishedOn = useSelector((state) => selectors.workflowMetadataById(state, workflowId)?.publishedOn);

  const handleReturnToPublished = () => {
    setPath(`/workflows/${workflowId}/published`, { keepSearch: true });
  };

  if (workflowVersion !== 'draft' || !publishedOn) {
    return null;
  }

  return (
    <>
      <Button className="return-button ghost" size="xs" icon={FiArrowLeft} onClick={handleReturnToPublished} title="Return to Published" />
      <DividerV2 mode={'vertical'} />
    </>
  );
};

export default WorkflowReturnToPublishedButton;
